// extracted by mini-css-extract-plugin
module.exports = {"root":"uJ0jS9vSPsn6T1aapJ9D","key":"fA5S503xAmMqHfcsYsU0","icon":"TakSFZS5IKuvuadzbelG"};